export default {
    login: "Iniciar sesión",
    email: "Correo electrónico",
    pass: "Contraseña",
    ingresar: "Ingresar",
    forgotPass: "¿Olvidaste tu contraseña?",
    recuperarPass: "Recuperar contraseña",
    noRegistrado: "¿No estás registrado?",
    crearCuenta: "Crear cuenta",
    tieneCuenta: "¿Ya tienes una cuenta?",
    cuentaVencidaTitulo: "¡Su cuenta de SatWeb ha vencido!",
    cuentaVencidaText: "Debe renovar la suscripción para poder volver a utilizar SatWeb",
    cuentaFreeVencidaTitulo: "¡Su cuenta de SatWeb Gratuita ha vencido!",
    cuentaFreeVencidaText: "Debe suscribirse a un plan para poder utilizar SatWeb",
    comprarAhora: "Comprar ahora",
    renovarAhora: "Renovar ahora",
    errorEmailPass: "Debes ingresar el correo y la contraseña",
    errorEmail: "Debes ingresar el correo",
    errorPass: "Debes ingresar la contraseña",
    acuerdo: "Al hacer clic en siguiente, estoy de acuerdo con los",
    terminos: "Términos de uso",
    siguiente: "Siguiente",
    textCelular: "Ingresa tu número de celular para activar tu cuenta de SatWeb",
    enviarSMS: "Enviar SMS de confirmación",
    errorCelular: "Por favor ingresa un número de celular valido",
    placeholderCelular: "Número de celular",
    nuevaPass: "Nueva contraseña",
    confirmPass: "Confirmar contraseña",
    passLargo: "La contraseña debe tener al menos 8 caracteres.",
    passMayus: "La contraseña debe contener al menos una letra mayúscula.",
    passMinuscula: "La contraseña debe contener al menos una letra minúscula.",
    passNum: "La contraseña debe contener al menos un número.",
    passCaracter: "La contraseña debe contener al menos un caracter especial.",
    restablecerPass: "Restablecer contraseña",
    pregLogin: "¿Deseas iniciar sesión?",
    emailVacio: "Por favor ingresa un correo electrónico",
    emailInvalido: "Correo electrónico inválido",
    enviarEmail: "Enviar correo",
    passActual: "Contraseña actual",
    noCoincide: "Las contraseñas no coinciden",
    errorCredenciales: "Error usuario o contraseña incorrecta",
    errorCuenta: "Error cuenta vencida",
}